import React from "react";
import classNames from "classnames";
import { SelectedIcon } from "@common/selectedIcon";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";

function CalendarHolidaysSelection({
  selectedCalendarHolidays,
  placeholder,
  calendarsHolidays,
  isDisabled,
  select,
  clearSelection,
}: Props) {
  const [isVisible, setIsVisible] = React.useState(false);
  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);
  const { t } = useTranslation();
  return (
    <div
      className={classNames(styles.calendarSelection, {
        [styles.opened]: isVisible,
        [styles.disabled]: isDisabled,
      })}
    >
      <div className={styles.input} onClick={isVisible ? hide : show}>
        {!!selectedCalendarHolidays ? (
          <p className={styles.selection}>{selectedCalendarHolidays.name}</p>
        ) : (
          <p className={classNames(styles.selection, styles.placeholder)}>
            {placeholder}
          </p>
        )}
        <div className={styles.iconBox}>
          <ArrowIcon className={styles.icon} />
        </div>
      </div>
      {isVisible && !isDisabled && (
        <div className={styles.list}>
          {calendarsHolidays.map((calendar) => {
            const isSelected =
              !!selectedCalendarHolidays &&
              selectedCalendarHolidays.uuid === calendar.uuid;

            return (
              <div
                key={calendar.uuid}
                className={classNames(styles.calendar, {
                  [styles.selected]: isSelected,
                })}
                onClick={() => {
                  select(calendar);
                  hide();
                }}
              >
                <p className={styles.calendarName}>{calendar.name}</p>
                {isSelected && (
                  <SelectedIcon className={styles.selectedCalendarIcon} />
                )}
              </div>
            );
          })}

          {selectedCalendarHolidays && (
            <div
              className={styles.clear}
              onClick={() => {
                clearSelection();
                hide();
              }}
            >
              {t("editResource.default")}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export { CalendarHolidaysSelection };
